import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=4232a73a"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports